import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <span
            aria-hidden='true'
            className={cn(
                'grid size-9 shrink-0 place-items-center rounded-xl bg-linear-to-br from-[#9b5cff] to-[#6d28d9] text-white shadow-md shadow-primary/30',
                className
            )}
        >
            <svg viewBox='0 0 64 64' className='size-[62%]' fill='none'>
                <path
                    d='M32 15v24m0 0-10-10m10 10 10-10M19 47h26'
                    stroke='currentColor'
                    strokeWidth='6'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        </span>
    )
}

interface LogoProps {
    className?: string
}

export const Logo: FC<LogoProps> = ({ className }): ReactNode => {
    return (
        <Link
            href='/'
            className={cn('group inline-flex items-center gap-2.5 rounded-xl outline-none focus-visible:ring-4 focus-visible:ring-ring/30', className)}
        >
            <LogoMark className='transition-transform duration-300 group-hover:-rotate-6 motion-reduce:transition-none' />

            <span className='font-heading text-xl font-bold tracking-tight text-foreground'>
                Cave
                <span className='text-primary'>
                    DL
                </span>
            </span>
        </Link>
    )
}
